<template>

  <div class="catalog-category" v-if="category">

    <div class="catalog-category__item">
      <div class="catalog-category__subtitle">

        <div class="catalog-category__item-more catalog-category__item-more--left">
          <md-button class="md-icon-button" md-menu-trigger>
            <md-icon class="drag-indicator">drag_indicator</md-icon>
          </md-button>
        </div>

        <h2 class="md-title">{{category.name}}</h2>
        <md-menu class="catalog-category__item-more catalog-category__item-more--right" :mdCloseOnClick=true>
          <md-button class="md-icon-button" md-menu-trigger>
            <md-icon>more_vert</md-icon>
          </md-button>
          <md-menu-content>
            <md-menu-item>
              <span class="catalog__item-more-link" @click="editCategory(category)">Bearbeiten</span>
            </md-menu-item>
            <md-menu-item>
              <span class="catalog__item-more-link" @click="deleteCatalogCategory(category.id)">Löschen</span>
            </md-menu-item>
          </md-menu-content>
        </md-menu>
      </div>
      <div class="catalog__divider"></div>
    </div>

    <draggable class="catalog__items"
               v-model="itemsList"
               @end="changed($event)"
               @start="drag = true"
               :animation="200"
               ghostClass="ghost"
               handle=".drag-indicator">
      <transition-group type="transition" class="catalog__item" v-for="item in itemsList" :key="item.id">
        <div :key="item.id">
          <md-button class="catalog__item-drag md-icon-button">
            <md-icon class="drag-indicator">drag_indicator</md-icon>
          </md-button>
          <md-menu class="catalog__item-more" :mdCloseOnClick=true>
            <md-button class="md-icon-button" md-menu-trigger>
              <md-icon>more_vert</md-icon>
            </md-button>
            <md-menu-content>
              <md-menu-item>
                <span class="catalog__item-more-link" @click="editItem(item)">Bearbeiten</span>
              </md-menu-item>
              <md-menu-item>
                <span class="catalog__item-more-link" @click="deleteCatalogItem(item.id)">Löschen</span>
              </md-menu-item>
            </md-menu-content>
          </md-menu>
          <catalog-item :item="item"></catalog-item>
        </div>
      </transition-group>
    </draggable>

    <md-dialog-confirm
        :md-active.sync="activeConfirm"
        md-title="Sicher?"
        md-content=""
        md-confirm-text="Ja"
        md-cancel-text="Nein"
        @md-confirm="onConfirmDeleteItem"/>

    <md-dialog-confirm
        :md-active.sync="activeConfirmCategory"
        md-title="Wollen Sie diese Kategorie wirklich löschen?"
        md-content="Die zugewiesenen Elemente werden auch gelöscht."
        md-confirm-text="Ja"
        md-cancel-text="Nein"
        @md-confirm="onConfirmDeleteCategory"/>

  </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import CatalogItem from './CatalogItem'
    import draggable from 'vuedraggable'

    export default {
        name: "CatalogCategory",
        components: {
            CatalogItem,
            draggable
        },
        props: [
            'category'
        ],
        data() {
            return {
                activeConfirm: false,
                activeConfirmCategory: false,
                selectedItemId: null,
                showSnackbar: false,
                snackbarMessage: null,
                itemsList: [],
                drag: false,
                showEditDialog: false
            }
        },
        mounted() {
            this.updateItemsList();
        },
        watch: {
            category: function() {
                this.updateItemsList();
            }
        },
        computed: {
            ...mapGetters('auth', [
                'user'
            ]),
        },
        methods: {
            ...mapActions('catalog', [
                'loadItems',
                'editItem',
                'editCategory',
                'deleteItem',
                'deleteCategory',
                'updateOrder'
            ]),
            updateItemsList: function() {
                this.itemsList = this.category.items
            },
            changed: async function (event) {
                this.drag = false
                if(event.newIndex !== event.oldIndex) {
                    let payload = {
                        items: this.itemsList,
                        locationId: this.user.locationId
                    }
                    await this.updateOrder(payload)
                    this.showSnackbar = true
                }
            },
            deleteCatalogItem: function (id) {
                this.selectedItemId = id
                this.activeConfirm = true
            },
            deleteCatalogCategory: function (id) {
                this.selectedCategoryId = id
                this.activeConfirmCategory = true
            },
            onConfirmDeleteItem: async function () {
                let payload = {
                    id: this.selectedItemId,
                    locationId: this.user.locationId
                }
                await this.deleteItem(payload)
                this.selectedItemId = null
            },
            onConfirmDeleteCategory: async function () {
                let payload = {
                    id: this.selectedCategoryId,
                    locationId: this.user.locationId
                }
                await this.deleteCategory(payload)
                this.selectedCategoryId = null
            }
        }
    }
</script>

<style>
  .ghost {
    opacity: 0.5;
  }

  .move {
    transform: scale(.5);
  }
</style>
